import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	buttonLabel: {
		id: 'polaris-ideas.view-controls.manage-bar.unarchive-ideas.button-label',
		defaultMessage: 'Restore',
		description: 'Button label to unarchive selected ideas',
	},
});
